<template>
  <div class="container-xxl flex-grow-1 container-p-y">
    <div
      class="card mb-6 border border-2 border-primary rounded primary-shadow"
    >
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-start">
          <div class="d-flex justify-content-center">
            <h2 class="mb-0 text-primary">8 Mbps</h2>
          </div>
          <div class="d-flex justify-content-center">
            <sub class="h5 pricing-currency mb-auto mt-1 text-primary">₺</sub>
            <h2 class="mb-0 text-primary">549.90</h2>
            <sub class="h6 pricing-duration mt-auto mb-3 fw-normal">month</sub>
          </div>
        </div>
        <div
          class="d-flex justify-content-between align-items-center mb-1 mt-4"
        >
          <span class="h6 mb-0">Days</span>
          <span class="h6 mb-0">26 of 30 Days</span>
        </div>
        <div class="progress mb-1 bg-label-primary" style="height: 6px">
          <div
            class="progress-bar"
            role="progressbar"
            style="width: 65%"
            aria-valuenow="65"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <small>4 days remaining</small>
        <div class="row">
          <div class="col-md-6">
            <div class="d-grid w-100 mt-4">
              <button
                class="btn btn-primary"
                data-bs-target="#changeSubscriptionModal"
                data-bs-toggle="modal"
              >
                <i class="ti ti-refresh ti-xs me-2"></i>
                <span>Change Subscription</span>
              </button>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-grid w-100 mt-4">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-info dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i class="ti ti-reload ti-xs me-2"></i>
                  <span>Renew Type (Manual)</span>
                </button>
                <ul class="dropdown-menu w-100">
                  <li>
                    <a
                      type="button"
                      class="dropdown-item"
                      @click="confirmRenewManual"
                      >Manual</a
                    >
                  </li>
                  <li>
                    <a
                      type="button"
                      class="dropdown-item"
                      @click="confirmRenewAuto"
                      >Auto</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="d-grid w-100 mt-4">
              <button
                type="button"
                class="btn btn-success"
                @click="confirmAdd2FreeDays"
              >
                <i class="ti ti-calendar-plus ti-xs me-2"></i>
                <span>Add 2 Free Days</span>
              </button>
            </div>
          </div>

          <div class="col-md-4">
            <div class="d-grid w-100 mt-4">
              <button
                class="btn btn-warning"
                data-bs-target="#tempSpeedModal"
                data-bs-toggle="modal"
              >
                <i class="ti ti-gauge ti-xs me-2"></i>
                <span>Temporary Speed Change</span>
              </button>
            </div>
          </div>

          <div class="col-md-4">
            <div class="d-grid w-100 mt-4">
              <button
                class="btn btn-danger waves-effect waves-light"
                @click="confirmDisconnect"
              >
                <span>
                  <i class="ti ti-wifi-off ti-xs me-2"></i>
                  <span>Disconnect</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script></script>
